import React from 'react';

import { Box, Typography } from '@mui/material';

import { EMPTY_INBOX_CONTENT_IMG } from 'src/assets';
import type { SxProp } from 'src/types/mui';

export const InboxEmptyWrapper: React.FC = () => {
  return (
    <Box sx={emptyInboxContentStyles}>
      <img style={{ width: '260px' }} alt="Empty inbox" src={EMPTY_INBOX_CONTENT_IMG} />
      <Typography variant="h1" mt={3.5} sx={headingStyles}>
        There are no requests
      </Typography>
      <Typography variant="body2" mt={2} sx={subtitleStyle}>
        Here you will see the requests related to you
      </Typography>
    </Box>
  );
};

const emptyInboxContentStyles: SxProp = theme => ({
  display: 'flex',
  flexFlow: 'column nowrap',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  p: 5,
  border: theme.constantStyles?.paperBorder,
  borderRadius: theme.constantStyles?.paperBorderRadius,
  [theme.breakpoints.down('sm')]: {
    border: 'none',
  },
});

const headingStyles: SxProp = theme => ({
  fontSize: '32px',
  fontWeight: '600',
  width: '400px',
  textAlign: 'center',
  marginRight: '30px',
  [theme.breakpoints.down('sm')]: {
    marginRight: '0',
  },
});

const subtitleStyle: SxProp = theme => ({
  width: '420px',
  textAlign: 'center',
  marginRight: '30px',
  [theme.breakpoints.down('sm')]: {
    marginRight: '0',
  },
});
